import { Component, effect, Input, SimpleChanges } from "@angular/core";
import { DonorCardService } from "../../../services/donor-card.service";
import { TableModule } from "primeng/table";
import { GenericButtonComponent } from "../../../../global/component/generic/generic-button/generic-button.component";
import { ButtonModule } from "primeng/button";
import { CommonModule } from "@angular/common";
import { SharedService } from "../../../services/shared.service";
import { DialogModule } from "primeng/dialog";
import { DonationsAddComponent } from "../../donations-add/donations-add.component";
import { Router } from "@angular/router";

@Component({
    selector: 'app-donor-donations',
    templateUrl: './donor-donations.component.html',
    styleUrls: ['./donor-donations.component.scss'],
    standalone: true,
    imports: [GenericButtonComponent,
        TableModule,
        ButtonModule,
        CommonModule,
        DialogModule,
        DonationsAddComponent
    ],
    providers: [DonorCardService, SharedService]
})
export class DonorDonationsComponent {
    @Input() donorId?: number;
    @Input() campaignId?: number;
    
    donorDonations: any = [];
    showAddDonationDialog: boolean = false;

    constructor(
        private router: Router,
        public sharedService: SharedService,
        private donorCardService: DonorCardService,
    ) {
        effect(() => {
            this.loadDonorLetters();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['donorId'] || changes['campaignId']) {
            this.loadDonorLetters();
        }
    }

    loadDonorLetters(): void {
        if (this.donorId && this.campaignId) {
            this.donorCardService.getDonorDonations(this.campaignId, this.donorId).subscribe({
                next: data => {
                    this.donorDonations = data;
                },
                error: err => {
                    console.error('Unable to retrieve donor donations. Please try again later.', err);
                },
            });
        }
    }

    onAddDonation() {
        this.router.navigate(['vortex/donations/add-new-donation'], {
            queryParams: { source: 'donorCard', donorId: this.donorId }
        });
    }
}
